import React from 'react'
import { docsDrawerWidth } from '../../Utils/constants'
import { Box, Divider, Drawer, List, ListSubheader, Toolbar } from '@mui/material'
import NavbarLink from '../../Components/NavbarLink'
import routes from '../../Config/routes'

export default function DocsNavbar({isDesktop, isOpen, onClose}) {

    return (
        <Drawer
            variant={isDesktop ? "permanent" : "temporary"}
            open={isDesktop || isOpen}
            onClose={onClose}
            sx={{
                position: 'relative',
                width: docsDrawerWidth,
                flexShrink: 0,
                zIndex: (theme)=>isDesktop ? theme.zIndex.appBar-1 : theme.zIndex.drawer,
                [`& .MuiDrawer-paper`]: { width: docsDrawerWidth, boxSizing: 'border-box' },
            }}>
            {isDesktop&&<Toolbar />}
            <Box sx={{ overflow: 'auto' }}>
                <List>
                    <ListSubheader>Getting Started</ListSubheader>
                    <NavbarLink primary={'Introduction'} to={routes.intDocsHome}></NavbarLink>
                    <Divider></Divider>
                    <NavbarLink primary={'Frontend'} to={routes.intDocsFrontend}></NavbarLink>
                    <NavbarLink primary={'Backend'} to={routes.intDocsBackend}></NavbarLink>
                </List>
            </Box>
        </Drawer>
    )
}
